document.addEventListener("DOMContentLoaded", function(event) {

    
    let vendors = document.querySelectorAll('.grid-product__vendor');
    let titles = document.querySelectorAll('.grid-product__title--clamp');
    let prices = document.querySelectorAll('.grid-product__price');
    
    if (vendors.length) {
    let intervalId = setInterval(function() {
        let maxHeight = 0;

        vendors.forEach(function(vendor) {
        let height = vendor.clientHeight;
        maxHeight = Math.max(maxHeight, height);
        });

        vendors.forEach(function(vendor) {
        vendor.style.height = maxHeight + 'px';
        });
    }, 200);

    setTimeout(function() {
        clearInterval(intervalId);
    }, 3000);
    };
    
    if (titles.length) {
        let intervalIdTitle = setInterval(function() {
            let maxHeight = 0;
    
            titles.forEach(function(title) {
            let height = title.clientHeight;
            maxHeight = Math.max(maxHeight, height);
            
            });
    
            titles.forEach(function(title) {
                title.style.height = maxHeight + 'px';
            });
        }, 200);
        setTimeout(function() {
            clearInterval(intervalIdTitle);
        }, 3000);
    }

    if (prices.length) {
        let intervalIdPrice = setInterval(function() {
            let maxHeight = 0;
    
            prices.forEach(function(price) {
            let height = price.clientHeight;
            maxHeight = Math.max(maxHeight, height);
            
            });
    
            prices.forEach(function(price) {
                price.style.height = maxHeight + 'px';
            });
        }, 200);
        setTimeout(function() {
            clearInterval(intervalIdPrice);
        }, 3000);
    }

    /* Dynamic percentage calculate from variants */
    let percentageBadge = document.querySelector('.product-block--price .grid-product__tag--sale');
    let variantBtns = document.querySelectorAll('.variant-input.variation');
    variantBtns.forEach(function(variantBtn){
        variantBtn.addEventListener('click', function(e){
            setTimeout(function(){
                let priceField = document.querySelector('.product__price.product__price--compare');
            if (priceField) {
                let priceSale = document.querySelector('.product__price.on-sale').textContent;
                let cleanPrice = priceField.textContent.replace(/[\.,a-zA-Z]/g, '');
                let cleanSale = priceSale.replace(/[\.,a-zA-Z]/g, '');
                let percentageCalc = Math.round((cleanPrice - cleanSale) * 100 / cleanPrice);
                let customSavedClass = "custom-saved";
                let percentageText = `Spar: <span class="${customSavedClass}">${percentageCalc}%</span>`;
                percentageBadge.innerHTML  = percentageText;
            };
            },100)
        });
    });
    setTimeout(function(){
        let priceField = document.querySelector('.product__price.product__price--compare');
    if (priceField) {
        let priceSale = document.querySelector('.product__price.on-sale').textContent;
        let cleanPrice = priceField.textContent.replace(/[\.,a-zA-Z]/g, '');
        let cleanSale = priceSale.replace(/[\.,a-zA-Z]/g, '');
        let percentageCalc = Math.round((cleanPrice - cleanSale) * 100 / cleanPrice);
        let customSavedClass = "custom-saved";
        let percentageText = `Spar: <span class="${customSavedClass}">${percentageCalc}%</span>`;
        percentageBadge.innerHTML  = percentageText;
    };
    },100)

    function dynamicBadge() {
        let badges = document.querySelectorAll('.grid-product__tag--sale');
        if (badges && badges.length) {
            badges.forEach(function(badge, idx) {
                let parentEle = badge.parentNode;
                if (!parentEle) {
                    console.warn(`[dynamicBadge] Badge at index ${idx} has no parentNode.`);
                    return;
                }
                let comparePriceElem = parentEle.querySelector('.grid-product__price--original');
                let salePriceElem = parentEle.querySelector('.grid-pricing');
                if (!comparePriceElem || !salePriceElem) {
                    console.warn(`[dynamicBadge] Missing price elements for badge at index ${idx}.`, { comparePriceElem, salePriceElem });
                    return;
                }
                let comparePrice = comparePriceElem.textContent;
                let salePrice = salePriceElem.textContent;
                let cleanCompare = comparePrice.replace(/[\.,a-zA-Z]/g, '');
                let cleanSale = salePrice.replace(/[\.,a-zA-Z]/g, '');
                if (!cleanCompare || !cleanSale || isNaN(Number(cleanCompare)) || isNaN(Number(cleanSale))) {
                    console.warn(`[dynamicBadge] Invalid price values for badge at index ${idx}.`, { cleanCompare, cleanSale });
                    return;
                }
                let percentageCalc = Math.round((cleanCompare - cleanSale) * 100 / cleanCompare);
                let customSavedClass = "custom-saved";
                let percentageText = `Spar: <span class="${customSavedClass}">${percentageCalc}%</span>`;
                badge.innerHTML  = percentageText;
            });
        }
    }
    dynamicBadge();

    function initLinkedProductHover() {
        let gridItems = document.querySelectorAll(".grid__item.grid-product");

        gridItems.forEach((gridItem, gridIndex) => {
            let linkedItems = gridItem.querySelectorAll(".linked-products__item");
            let mainImage = gridItem.querySelector(".main-product-image");
            let linkedImages = gridItem.querySelectorAll(".linked-product__image");

            // Only proceed if linked images exist
            if (linkedImages.length > 0 && linkedItems.length > 0) {
                linkedItems.forEach((item, itemIndex) => {
                    // Remove previous event listeners by cloning (optional, prevents stacking)
                    let newItem = item.cloneNode(true);
                    item.parentNode.replaceChild(newItem, item);
                    item = newItem;

                    item.addEventListener("mouseenter", () => {
                        const index = item.getAttribute("data-image-index");

                        // Hide all linked images
                        linkedImages.forEach((img) => {
                            img.style.display = "none";
                        });

                        if (mainImage) {
                            mainImage.style.display = "none";
                        }

                        // Show the corresponding linked product image
                        const linkedImage = gridItem.querySelector(
                            `.linked-product-image--${index}`
                        );
                        if (linkedImage) {
                            linkedImage.style.display = "block";
                        } else {
                            console.error(`No linked image found for index: ${index}`);
                        }
                    });

                    item.addEventListener("mouseleave", () => {
                        // Hide all linked product images and show the main image
                        linkedImages.forEach((img) => {
                            img.style.display = "none";
                        });

                        if (mainImage) {
                            mainImage.style.display = "block";
                        }
                    });
                });
            } else {
                console.warn(`Grid item ${gridIndex + 1} skipped: No linked images or linked items found`);
            }
        });
    }

    initLinkedProductHover();

    (function() {
        const originalFetch = window.fetch;
        window.fetch = function(...args) {
            if (args[0] && typeof args[0] === "string" && args[0].includes("main-collection&")) {
                setTimeout(() => {
                    initLinkedProductHover();
                    console.log("Fetch called with filter");
                    
                    document.querySelectorAll('.collection-sidebar .tag--remove .btn').forEach(function(btn) {
                        btn.addEventListener('click', function(event) {
                            initLinkedProductHover();
                            console.log('Clicked inside .collection-sidebar .tag--remove .btn');
                        });
                    });
                }
                , 1000);
                document.dispatchEvent(new CustomEvent("filterFetch", { detail: args[0] }));
            }
            return originalFetch.apply(this, args);
        };
    })();

    document.querySelectorAll('.collection-sidebar .tag--remove .btn').forEach(function(btn) {
        btn.addEventListener('click', function(event) {
            initLinkedProductHover();
            console.log('Clicked inside .collection-sidebar .tag--remove .btn');
        });
    });

    let slidesWrapper = document.querySelector('.announcement-slider__slides');
    let messages = slidesWrapper ? slidesWrapper.querySelector('.sliding-messages') : null;
    let slides = messages ? messages.querySelectorAll('.announcement-slider__slide') : [];
    let slideCount = slides.length;
    let slideHeight = slides[0] ? slides[0].offsetHeight : 0;
    let current = 0;

    if (slideCount > 1 && messages) {
        setInterval(() => {
        current = (current + 1) % slideCount;
        messages.style.transform = `translateY(-${current * slideHeight}px)`;
        }, 2000); // Change slide every 4 seconds
    }

    // Custom search field toggle for mobile
    const searchOpener = document.querySelector('.mobile-header-search-opener');
    const searchField = document.querySelector('.mobile-search-field');

    if (searchOpener && searchField) {
        searchOpener.addEventListener('click', () => {
            if (searchField.classList.contains('active')) {
                searchField.classList.remove('active');
            } else {
                searchField.classList.add('active');
            }
        });
        // Remove .active if click is outside searchOpener and searchField
        document.addEventListener('click', function(event) {
            if (
                searchField.classList.contains('active') &&
                !searchField.contains(event.target) &&
                !searchOpener.contains(event.target)
            ) {
                searchField.classList.remove('active');
            }
        });
    }

    
    // Trustpilot box no z-index
    (function () {
        var WIDGET_ID = 'trustpilot-widget-trustbox-1';

        function neutralize(el) {
            if (!el) return false;
            if (el.style.zIndex !== 'auto') {
            el.style.setProperty('z-index', 'auto', 'important');
            // Fjern kommentaren nedenfor, hvis 'position: relative' også driller:
            // el.style.setProperty('position', 'static', 'important');
            }
            return true;
        }

        // Måske er elementet der allerede
        if (neutralize(document.getElementById(WIDGET_ID))) return;

        // Ellers: vent på at det dukker op
        var observer = new MutationObserver(function () {
            var el = document.getElementById(WIDGET_ID);
            if (el) {
            neutralize(el);
            // Vi bliver ved med at observere, hvis Trustpilot sætter z-index tilbage.
            // Vil du stoppe efter første gang, så fjern kommentaren nedenfor:
            // observer.disconnect();
            }
        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style'],
        });
        })();


        // Cart Upsell Function
        (function () {
    function setLast(handleOrId) {
        fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _last_added: handleOrId } })
        });
    }
    function handleAdded(data) {
        var h = null;
        if (data && data.items && data.items.length) h = data.items[data.items.length - 1].handle;
        else if (data && data.handle) h = data.handle;
        if (h) setLast(h);
    }
    var oFetch = window.fetch;
    window.fetch = function () {
        var args = arguments, p = oFetch.apply(this, args);
        try {
        var u = (args[0] && args[0].url) ? args[0].url : args[0];
        if (typeof u === 'string' && u.indexOf('/cart/add') !== -1) {
            p.then(function (r) { return r.clone().json(); }).then(handleAdded).catch(function(){});
        }
        } catch (e) {}
        return p;
    };
    })();


});